<script setup lang="ts">
import { UiButton } from '#components'
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger
} from 'reka-ui'
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
  bodyClass?: HTMLAttributes['class']
  headerClass?: HTMLAttributes['class']
  footerClass?: HTMLAttributes['class']
  toggleIcon?: string
  toggleClass?: HTMLAttributes['class']
  reverseToggle?: boolean
  defaultOpen?: boolean
}>()

const slots = useSlots()
const open = ref(props.defaultOpen || false)
</script>

<template>
  <CollapsibleRoot
    v-model:open="open"
    :class="
      cn(
        ' rounded-2xl bg-background dark:bg-surface-container shadow-[0_-1px_6px_-1px_rgba(0,0,0,0.1),0_1px_3px_0_rgba(0,0,0,0.1),0_1px_2px_-1px_rgba(0,0,0,0.1)]',
        {
          'p-5': !(slots.header || slots.footer)
        },
        props.class
      )
    "
  >
    <div v-if="slots.header" :class="cn('px-5 py-4 flex', props.headerClass)">
      <div class="grow">
        <slot name="header" />
      </div>
      <CollapsibleTrigger
        :as="UiButton"
        :icon="toggleIcon || 'material-symbols:expand-more'"
        :class="
          cn(
            'data-[state=open]:-rotate-180 p-0.5 w-7 h-7 transition-transform border-0',
            props.toggleClass
          )
        "
        variant="primaryOutline"
      />
    </div>
    <Transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <CollapsibleContent
        class="data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp"
      >
        <div
          :class="
            cn(
              {
                'px-5 py-3.5': slots.header || slots.footer
              },
              props.bodyClass
            )
          "
        >
          <slot />
        </div>
        <div v-if="slots.footer" :class="cn('px-5 py-4', props.footerClass)">
          <slot name="footer" />
        </div>
      </CollapsibleContent>
    </Transition>
  </CollapsibleRoot>
</template>
